import { Component, ChangeDetectionStrategy, output, input } from '@angular/core';

@Component({
  selector: 'app-preview-influencer-nav',
  templateUrl: './preview-influencer-nav.component.html',
  styleUrls: ['./preview-influencer-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreviewInfluencerNavComponent {
  readonly name = input('');
  readonly index = input(0);
  readonly total = input(0);
  readonly loading = input<boolean | null>(false);
  readonly emptyLabel = input('Loading...');
  readonly previous = output<void>();
  readonly next = output<void>();
}
